import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { assetsApi } from 'core/api/assets.api';
import { setAxiosAuth } from 'utils';

export const useGetCategories = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.categories],
    queryFn: assetsApi.getCategories,
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken),
  });
};
